import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import StartupError from './StartupError.vue';
import { i18n } from './plugins/i18n.ts';
import { vuetify } from './plugins/vuetify.ts';
import { createAppRouter } from './router.ts';
import { startSession } from './auth/session.ts';
import { ApiKey, SessionKey, createApi } from './api/client.ts';
import './styles/app.css';

/**
 * The dashboard's entry point.
 *
 * The session comes first and the app second. Every page reads data that needs
 * a token, so mounting before the login would render each page once without
 * data and again with it, and would make "no data yet" and "not allowed"
 * indistinguishable for the few hundred milliseconds between them.
 *
 * Order matters in one other place: i18n before Vuetify, because Vuetify's
 * locale adapter reads from the i18n instance.
 */
try {
  // Resolves only when logged in. When not, keycloak-js navigates to the login
  // page and this promise never settles, which is the intended outcome.
  const session = await startSession(i18n.global.locale.value);
  createApp(App)
    .use(createPinia())
    .use(i18n)
    .use(vuetify)
    .use(createAppRouter())
    .provide(SessionKey, session)
    .provide(ApiKey, createApi(session))
    .mount('#app');
} catch (e) {
  console.error('StadtPuls could not start a session', e);
  createApp(StartupError).use(i18n).use(vuetify).mount('#app');
}
